import CurrencyInput from 'react-currency-input-field'
import TimeAgo from 'react-timeago-i18n'
import { WarningCircleIcon } from '@phosphor-icons/react'
import { CURRENCY_LONG, LOCALE } from 'utilities/global.variables'





const UpdateRowCard = ({ item, onValueChange }) => {

      const { name, description, classification, valuation, ownership, updated, include_networth } = item;

    var priority = "Low"
    const lastUpdated = new Date(updated)


    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

    const oneWeekAgo = new Date();
    oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);


    if(lastUpdated < oneWeekAgo ) { priority = "Medium" } 
    if(lastUpdated < oneMonthAgo ) { priority = "High" } 







    return (
      <div className="form-item ">
        
        <div className="flex row center medium-gap">
          <div className={`xsmall dot ${priority} `}  data-cls={priority}></div>
          <p className="medium truncate-1">{name}</p>
          <p className={`small flag ${priority} `} ><TimeAgo date={updated} /> </p>
        </div>


        <div className="flex row end ">
          <CurrencyInput intlConfig={{ locale: LOCALE, currency: CURRENCY_LONG.currency }} className="number medium " allowDecimals={false} allowNegativeValue={false} prefix="£" defaultValue={Math.abs(valuation)} size={10} onValueChange={onValueChange} />
        </div>

      </div>
    );
}

export default UpdateRowCard